module.exports = __webpack_public_path__ + "img/droid-sans-light.798fd56f.png";